import { Kanban, ListDashes } from "@phosphor-icons/react";

const VIEWS = [
  { id: "kanban", label: "לוח תשלומים", icon: Kanban },
  { id: "list", label: "רשימה", icon: ListDashes },
];

/**
 * Finance view switcher (kanban / list) — design-language tab strip:
 * rectangular, flush selected background, elevated above the content.
 */
function FinanceViewTabs({ view, onViewChange }) {
  return (
    <div className="fin-view-tabs" role="tablist">
      {VIEWS.map((v) => {
        const Icon = v.icon;
        const isActive = view === v.id;
        return (
          <button
            key={v.id}
            type="button"
            role="tab"
            aria-selected={isActive}
            className={`fin-view-tab ${isActive ? "active" : ""}`}
            onClick={() => onViewChange(v.id)}
          >
            <Icon size={15} weight={isActive ? "fill" : "regular"} />
            <span>{v.label}</span>
          </button>
        );
      })}
    </div>
  );
}

export default FinanceViewTabs;
